export const ENV = (process.env.REACT_APP_ENV || 'production').trim();

export const API = (process.env.REACT_APP_API || 'https://api.openweathermap.org/data/2.5').trim();

export const API_KEY = (process.env.REACT_APP_API_KEY || '').trim();
